import { HttpErrorResponse } from '@angular/common/http';

export class LoadingFields {
  error: HttpErrorResponse | null = null;
  loaded = false;
  loading = false;
  failed = false;
}

export class LoadingState extends LoadingFields {
  static from(state: LoadingState): LoadingState {
    const { loading, loaded, failed, error } = state;
    return { loading, loaded, failed, error };
  }

  /**
   * Gets the loading states chained in order.
   * If one fails or is still loading, then that's returned else next is evaluated.
   * Only loaded if last succeeds.
   */
  static chain(...states: LoadingState[]): LoadingState {
    return LoadingState.from(states.reduce((previous, next) => (previous.loading || previous.failed ? previous : next), LoadingState.initial()));
  }

  static initial(): LoadingState {
    return {
      error: null,
      loaded: false,
      loading: false,
      failed: false,
    };
  }

  static loading(): LoadingState {
    return {
      error: null,
      loaded: false,
      loading: true,
      failed: false,
    };
  }

  static loaded(): LoadingState {
    return {
      error: null,
      loaded: true,
      loading: false,
      failed: false,
    };
  }

  static failed(error?: HttpErrorResponse): LoadingState {
    return {
      error: error ?? null,
      loaded: false,
      loading: false,
      failed: true,
    };
  }
}

export class LoadingEntity<T> extends LoadingFields {
  entity: T;

  static initial<T>(): LoadingEntity<T> {
    return {
      entity: null,
      ...LoadingState.initial(),
    };
  }

  static loading<T>(keepEntity = false): LoadingEntity<T> {
    return {
      ...(!keepEntity && { entity: null }),
      ...LoadingState.loading(),
    };
  }

  static loaded<T>(entity: T): LoadingEntity<T> {
    return {
      entity,
      ...LoadingState.loaded(),
    };
  }

  static failed<T>(error?: HttpErrorResponse): LoadingEntity<T> {
    return {
      entity: null,
      ...LoadingState.failed(error),
    };
  }
}
